import {createShipping} from "../../Library/libraryFactory";
import {isNullOrUndefined} from "../../../Utilities/commonUtilities";
import {
    getFormatTextByValue,
    getOrderStatusTextByValue,
    getOrderTypeTextByValue
} from "../orderUtility";
import {convertDateToPrintString} from "../../../Utilities/Types/dateUtilities";
import {ORDER_STATUS} from "../orderConstants";
import {isObjectNullOrEmpty} from "../../../Utilities/Types/objectUtilities";

function createDetails({
    accessNumber,
    alternateFormat,
    author,
    format,
    isbn,
    itemName,
    needFrom,
    needTo,
    notes,
    orderStatus,
    orderType,
    seriesTitle,
    student,
    patron,
    poNumber,
    cost,
    dateOrderSentToVendor,
    dateOrderReceivedFromVendor,
    totalNumberOfVolumesReceived,
    vendorName
}: Record<string, any>) {
    let details = "";

    const hasAccessNumber = !isNullOrUndefined(accessNumber);
    const hasStudent = !isNullOrUndefined(student);
    const hasPatron = !isNullOrUndefined(patron);
    const hasNeedFrom = !isNullOrUndefined(needFrom);
    const hasNeedTo = !isNullOrUndefined(needTo);
    const hasMediumRequested = !isNullOrUndefined(format);
    const hasAuthor = !isNullOrUndefined(author);
    const hasSeriesTitle = !isNullOrUndefined(seriesTitle);
    const hasAlternateMedium = !isNullOrUndefined(alternateFormat);
    const hasOrderStatus = !isNullOrUndefined(orderStatus);
    const hasPONumber = !isNullOrUndefined(poNumber);
    const hasCost = !isNullOrUndefined(cost);
    const hasDateOrderSentToVendor = !isNullOrUndefined(dateOrderSentToVendor);
    const hasDateOrderReceivedFromVendor = !isNullOrUndefined(dateOrderReceivedFromVendor);
    const hasTotalNumberOfVolumesReceived = !isNullOrUndefined(totalNumberOfVolumesReceived);
    const hasVendorName = !isNullOrUndefined(vendorName) && !isObjectNullOrEmpty(vendorName);
    const hasNotes = !isNullOrUndefined(notes);

    //item
    details += `<b class="h3"> Request Details: </b>`;
    details += hasPatron ? `<div><b>${hasStudent ? "Patron" : "User"} Email:</b> ${patron.email}</div>` : "";
    details += hasStudent ? `<div><b>Student:</b> ${createStudent(student)}</div>` : "";
    details += hasSeriesTitle ? `<div><b>Series Title:</b> ${seriesTitle}</div>` : "";
    details += `<div><b>Item:</b> ${itemName}`;
    details += hasAuthor ? `<div><b>Author:</b> ${author}` : "";
    details += `<div><b>ISBN:</b> ${isbn}</div>`;
    details += hasMediumRequested ? `<div><b>Medium Requested:</b> ${getFormatTextByValue(format)}</div>` : "";
    details += hasAlternateMedium ? `<div><b>Alternate Medium:</b> ${getFormatTextByValue(alternateFormat)}</div>` : "";
    details += hasAccessNumber ? `<div><b>Access Number:</b> ${accessNumber}</div>` : "";
    details += hasStudent && hasNeedFrom ? `<div><b>Need From:</b> ${convertDateToPrintString(needFrom)}</div>` : "";
    details += hasNeedTo ? `<div><b>Need To:</b> ${convertDateToPrintString(needTo)}</div>` : "";
    details += hasNotes ? `<div><b>Notes:</b> ${notes}</div>` : "";

    if (orderStatus.toString() !== ORDER_STATUS.OrderReceivedFromPatron.id.toString()) {
        details += `<br/><b class="h3">Order Processing Details:</b>`;
        details += `<div><b>Order Type:</b> ${getOrderTypeTextByValue(orderType)}</div>`;
        details += hasOrderStatus ? `<div><b>Order Status:</b> ${getOrderStatusTextByValue(orderStatus)}</div>` : "";
        details += hasDateOrderSentToVendor ? `<div><b>Date Order Sent To Vendor:</b> ${convertDateToPrintString(dateOrderSentToVendor)}</div>` : "";
        details += hasDateOrderReceivedFromVendor ? `<div><b>Date Order Received From Vendor:</b> ${convertDateToPrintString(dateOrderReceivedFromVendor)}</div>` : "";
        details += hasTotalNumberOfVolumesReceived ? `<div><b>Volumes Received:</b> ${totalNumberOfVolumesReceived}</div>` : "";
        details += hasPONumber ? `<div><b>PO#:</b> ${poNumber}</div>` : "";
        details += hasCost ? `<div><b>Cost:</b> $${cost}</div>` : "";
        details += hasVendorName ? `<div><b>Vendor:</b> ${vendorName}</div>` : "";
    }

    return details;
}

function createStudent(student: Record<string, string>) {
    return `${student.firstName || ""} ${student.middleName || ""} ${student.lastName || ""}`;
}


export const orderDetailsModel = ({
                                      accessNumber,
                                      orderId,
                                      alternateCopyright,
                                      alternateFormat,
                                      author,
                                      catalogFormatId,
                                      copyright,
                                      description,
                                      format,
                                      gradeLevel,
                                      isbn,
                                      itemName,
                                      needFrom,
                                      needTo,
                                      notes,
                                      orderType,
                                      publisherId,
                                      publisherName,
                                      queueStatus,
                                      seriesTitle,
                                      shippingLocationName,
                                      shippingLocationId,
                                      specialInstructions,
                                      studentId,
                                      studentName,
                                      patron,
                                      shippingLocation,
                                      student,
                                      orderStatus,
                                      poNumber,
                                      cost,
                                      dateOrderSentToVendor,
                                      dateOrderReceivedFromVendor,
                                      dateOrderReceivedFromVendorFormatted,
                                      numberOfVolumesReceived,
                                      totalNumberOfVolumesReceived,
                                      isOrderComplete,
                                      copyId,
                                      volumes,
                                      vendorId,
                                      vendorName
                                  }: Record<string, any> = {}) => ({
    accessNumber,
    orderId,
    alternateCopyright,
    alternateFormat,
    author,
    catalogFormatId,
    copyright,
    description,
    format,
    gradeLevel,
    isbn,
    itemName,
    needFrom,
    needTo,
    notes,
    orderType,
    publisherId,
    publisherName,
    queueStatus,
    seriesTitle,
    shippingLocationName,
    shippingLocationId,
    specialInstructions: specialInstructions || ``,
    studentId,
    studentName,
    orderStatus,
    poNumber,
    cost,
    dateOrderSentToVendor,
    dateOrderReceivedFromVendor,
    dateOrderReceivedFromVendorFormatted,
    numberOfVolumesReceived,
    totalNumberOfVolumesReceived,
    isOrderComplete: isNullOrUndefined(isOrderComplete) || isObjectNullOrEmpty(isOrderComplete) ? false : isOrderComplete,
    copyId,
    volumes,
    vendorId,
    vendorName,
    details: createDetails({
        accessNumber,
        alternateCopyright,
        alternateFormat,
        author,
        copyright,
        format,
        gradeLevel,
        isbn,
        itemName,
        needFrom,
        needTo,
        notes,
        orderStatus,
        orderType,
        publisherName,
        seriesTitle,
        student,
        patron,
        poNumber,
        cost,
        dateOrderSentToVendor,
        dateOrderReceivedFromVendor,
        numberOfVolumesReceived,
        totalNumberOfVolumesReceived,
        vendorName
    }),
    shipping: createShipping({patron, shippingLocation})
});

export const placeAnOrderModel = ({
                                      orderId,
                                      formatOrdered,
                                      orderStatus,
                                      isAlternateFormatOrdered = false,
                                      poNumber,
                                      cost,
                                      vendorId
                                  }: Record<string, any> = {}) => ({
    orderId,
    formatOrdered,
    orderStatus,
    isAlternateFormatOrdered,
    poNumber,
    cost,
    vendorId
});

export const receiveOrderModel = ({
                                      orderId,
                                      orderType,
                                      description,
                                      numberOfVolumesReceived,
                                      volumesReceived,
                                      isOrderComplete,
                                      poNumber,
                                      cost,
                                  }: Record<string, any> = {}) => ({
    orderId,
    orderType,
    description,
    numberOfVolumesReceived,
    volumesReceived,
    isOrderComplete,
    poNumber,
    cost,
});

export const fulfillOrderModel = ({
                                      orderId,
                                      poNumber,
                                      cost,
                                  }: Record<string, any> = {}) => ({
    orderId,
    poNumber,
    cost,
});

export const orderProcessingModel = ({
                                         orderId,
                                         formatOrdered,
                                         orderStatus,
                                         isAlternateFormatOrdered = false,
                                         poNumber,
                                         cost,
                                         orderType,
                                         description,
                                         numberOfVolumesReceived,
                                         volumesReceived,
                                         isOrderComplete,
                                         vendorId
                                     }: Record<string, any> = {}) => ({
    orderId,
    formatOrdered,
    orderStatus,
    isAlternateFormatOrdered,
    poNumber,
    cost,
    orderType,
    description,
    numberOfVolumesReceived,
    volumesReceived,
    isOrderComplete,
    vendorId
});




